<template lang="pug">
  span(data-cy="date-field") {{ data | formatDate }}
</template>

<script>
import { formatDate } from '@/Core/filters/dates';

export default {
  filters: {
    formatDate,
  },
  props: {
    data: {
      type: String,
    },
  },
};
</script>
